var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var _a;
import React, { useState } from 'react';
import { MdClose } from 'react-icons/md';
import { themeLss } from "../../lss";
import styled, { css } from "../../styled";
import { getPaletteText, getDarkPalette } from "../../utils/paletteConversions";
import { Flex } from '../Box';
import { Text } from '../Text';
var roundedBorder = function (_a) {
    var _b = _a.isRound, isRound = _b === void 0 ? false : _b, theme = _a.theme;
    return (isRound &&
        "\n      border-radius: " + (isRound ? theme.radii.xl : theme.radii.sm) + ";\n    ");
};
var palette = function (_a) {
    var _b = _a.palette, palette = _b === void 0 ? 'primary' : _b, _c = _a.hasOutline, hasOutline = _c === void 0 ? false : _c, theme = _a.theme;
    var text = theme.colors[getPaletteText(palette)];
    var main = theme.colors[palette];
    var dark = theme.colors[getDarkPalette(palette)];
    if (hasOutline) {
        return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border: ", ";\n      color: ", ";\n    "], ["\n      border: ", ";\n      color: ", ";\n    "])), theme.borders.regular, dark);
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border: ", ";\n    border-color: transparent;\n    color: ", ";\n    background-color: ", ";\n  "], ["\n    border: ", ";\n    border-color: transparent;\n    color: ", ";\n    background-color: ", ";\n  "])), theme.borders.regular, text, main);
};
var DeleteButton = styled.button(function (_a) {
    var theme = _a.theme;
    return "\n    display: inline-flex;\n    align-self: center;\n    padding: " + theme.space.xs + ";\n    margin-left: " + theme.space.sm + ";\n    margin-right: -" + theme.space.xs + ";\n    outline: none;\n    background: transparent;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n";
});
/**
 * Basic tag component
 */
var StyledTag = styled(Flex)(palette, roundedBorder, themeLss((_a = {
        textScale: 'content',
        fontWeight: 'regular',
        display: 'inline-flex',
        justifyContent: 'space-between',
        whiteSpace: 'nowrap',
        alignItems: 'center',
        py: 'xs',
        px: 'md'
    },
    _a[Text] = {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center'
    },
    _a)));
var ControlledTag = function (_a) {
    var _b = _a.textScale, textScale = _b === void 0 ? 'content' : _b, _c = _a.fontWeight, fontWeight = _c === void 0 ? 'regular' : _c, children = _a.children, onRemove = _a.onRemove, props = __rest(_a, ["textScale", "fontWeight", "children", "onRemove"]);
    var _d = __read(useState(true), 2), isVisible = _d[0], setIsVisible = _d[1];
    var handleRemove = function (e) {
        e.stopPropagation();
        setIsVisible(false);
        onRemove && onRemove();
    };
    if (!isVisible) {
        return null;
    }
    return (React.createElement(StyledTag, __assign({}, props),
        React.createElement(Text, { lss: {
                textScale: textScale,
                fontWeight: fontWeight
            } }, children),
        onRemove && (React.createElement(DeleteButton, { onClick: handleRemove, "aria-label": "Remove item", type: "button" },
            React.createElement(MdClose, { size: 15, color: "inherit" })))));
};
var UncontrolledTag = function (_a) {
    var _b = _a.textScale, textScale = _b === void 0 ? 'content' : _b, _c = _a.fontWeight, fontWeight = _c === void 0 ? 'regular' : _c, isVisible = _a.isVisible, children = _a.children, onRemove = _a.onRemove, props = __rest(_a, ["textScale", "fontWeight", "isVisible", "children", "onRemove"]);
    var handleRemove = function (e) {
        e.stopPropagation();
        onRemove && onRemove();
    };
    if (!isVisible) {
        return null;
    }
    return (React.createElement(StyledTag, __assign({}, props),
        React.createElement(Text, { lss: {
                textScale: textScale,
                fontWeight: fontWeight
            } }, children),
        onRemove && (React.createElement(DeleteButton, { onClick: handleRemove, "aria-label": "Remove item", type: "button" },
            React.createElement(MdClose, { size: 15, color: "inherit" })))));
};
export var Tag = function (_a) {
    var props = __rest(_a, []);
    return props.isVisible ? (React.createElement(UncontrolledTag, __assign({}, props))) : (React.createElement(ControlledTag, __assign({}, props)));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=Tag.js.map